import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="bg-black text-white py-6 px-6 md:px-20 font-poppins">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
        
        {/* Text Left */}
        <div className="text-center md:text-left space-y-1">
          <p className="text-sm">&copy; {new Date().getFullYear()} <strong>Nishar Hardware</strong>. All rights reserved.</p>
          <p className="text-xs text-gray-400">
            Designed and built with <span className="text-red-500">❤️</span> by Auxle.
          </p>
        </div>

        {/* Social Icons Right */}
        <div className="flex space-x-5 text-lg">
          <a href="https://www.facebook.com/nisharhardwaremumbai/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition">
            <FaFacebookF />
          </a>
          <a href="https://www.instagram.com/nishar_hardware/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition">
            <FaInstagram />
          </a>
          <a href="https://www.linkedin.com/company/nishar-hardware/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition">
            <FaLinkedinIn />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
